// Module
var code = `<h3 data-bind="label:'cc_Exists_Requests'">This request cannot be created due to the following open requests for this device:</h3>
        <table class="table table-striped">
            <thead>
                <tr>
                    <th data-bind="label:'C_RequestID'">Request ID</th>
                    <th data-bind="label:'Created'">Created</th>
                    <th data-bind="label:'Location'">Location</th>
                    <th data-bind="label:'CDeliveryAddress'">Address</th>
                    <th data-bind="label:'Postcode'">Postcode</th>
                    <th data-bind="label:'City'">City</th>
                    <th data-bind="label:'Country'">Country</th>
                    <th data-bind="label:'C_ContactFirstName'">Contact</th>
                    <th data-bind="label:'C_ContactLastName'"></th>
                    <th data-bind="label:'Phone'">Phone</th>
                    <th data-bind="label:'CDeliveryStatus'">Status</th>
                </tr>
            </thead>
            <tbody data-bind="foreach: existingRequests">
                <tr>
                    <td data-bind="text: request_id"></td>
                    <td data-bind="text: formattedcreated_dttm"></td>
                    <!-- ko with: place-->
                    <td data-bind="text: name"></td>
                    <!-- /ko -->
                    <!-- ko with: address -->
                    <td data-bind="text: address"></td>
                    <td data-bind="text: zippost"></td>
                    <td data-bind="text: city"></td>
                    <td data-bind="text: country"></td>
                    <!-- /ko -->
                    <!-- ko foreach: request_contact -->
                    <td data-bind="text: first_name"></td>
                    <td data-bind="text: last_name"></td>
                    <td data-bind="text: phone"></td>
                    <!-- /ko -->
                    <td data-bind="text: status"></td>
                </tr>
            </tbody>
        </table>`;
// Exports
module.exports = code;